import { createStyles, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';
import { COLUMN_INDICATOR_ADJUSTMENT } from '../../../../components/ScalarSpreadsheet/components/content-column/ContentColumns.util';

const useStyles = makeStyles((theme: ITheme) => ({
  heading: {
    paddingBottom: 0,
    paddingLeft: COLUMN_INDICATOR_ADJUSTMENT,
    paddingTop: theme.spacing(1),
  },
}));

export default useStyles;
